import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {Widget} from '@ispm/widgets/decorator/widget.decorator';
import {find, get} from 'lodash';
import {BundleCall} from "@ispm-client/modules/aggregator/services";
import {FileService} from "@ispm-client/modules/file-module/services/file.service";
import {WorkflowConfigService} from "@ispm/workflow/services/workflow-config.service";
import {DiagnosticOrderActionsService} from "@ispm/test/services/diagnostic-order-actions.service";
import {Store} from "@ngrx/store";
import {IgenomicsState} from "@ispm/core/interfaces/genomics-state.interface";
import {CORE_ACTIONS} from "@ispm/core/constants/core-actions.constant";
import {RouterManagerService} from "@ispm/core/services/router-manager.service";
import { Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'ispm-snapshot-file-viewer',
  templateUrl: './snapshot-file-viewer.component.html',
  styleUrls: ['./snapshot-file-viewer.component.scss']
})
@Widget('SnapshotFileViewer')
export class SnapshotFileViewerComponent implements OnInit , OnDestroy {
  widgetUpdateValueCallback: (value) => void;
  public widgetConfigPayload;
  revisionId:string;
  activeWorkflowRevision:string;
  diagnosticOrderId:string;
  public workflowId: string;
  selectedEventFile:any;
  file:any
  showSnapshotFile:boolean = false;
  private destroy$ = new Subject<void>();
  set widgetConfig(widgetConfig) {
  }

  set widgetData(widgetData: any) {
  }

  constructor(private routerManagerService: RouterManagerService, private _bundleCall:BundleCall,
              private _fileService:FileService,
              private _store: Store<IgenomicsState>,
              private diagnosticOrderActionsService: DiagnosticOrderActionsService,
              private workflowAC: WorkflowConfigService,
              private changeDetectorRef: ChangeDetectorRef) {

  }

  ngOnInit() {
    const diagnosticReportPayload: Array<any> = [];
    const documentReferencePayload: Array<any> = [];

    this.diagnosticOrderActionsService.getState()
          .pipe(
            filter(state => !!state.order),
            map(state => state.order),
            takeUntil(this.destroy$)
          ).subscribe(order => {
            this.diagnosticOrderId = order.id;

        if(this.diagnosticOrderId){
          this._store.dispatch({
            type: CORE_ACTIONS.SET_LOADER,
            payload: true
          });

          diagnosticReportPayload.push({
            "queryString": `context=true&requestID=${this.diagnosticOrderId}`,
            "targetResource": "DiagnosticReport"
          });

          this._bundleCall.searchCall({queries: diagnosticReportPayload}).subscribe( data => {
            const diagnosticOrderRecords = get(data[0], ['response', 'entry']);
            if (diagnosticOrderRecords.length > 0) {
              diagnosticOrderRecords.forEach((x) => {
                this.workflowId = x.resource.report;
                documentReferencePayload.push({
                  "queryString": `_id=${this.workflowId}`,
                  "targetResource": "DocumentReference"
                });
              });
              this._bundleCall.searchCall({queries:documentReferencePayload}).subscribe(data3 => {
                let individualWorkflowRequest = get(data3[0], ['response', 'entry','0','resource','context']);
                let fileResourceId  = find(individualWorkflowRequest,['resourceType', 'FileResource']).reference;
                this.selectedEventFile = fileResourceId;
                this.showSnapshotFile = true;
                this.changeDetectorRef.markForCheck();
                this.changeDetectorRef.detectChanges();
              });

            }
          })
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
